import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { Observable, Subscription } from 'rxjs';
import { HospitalService } from '../_services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss']
})
export class BoardComponent implements OnInit , OnDestroy{
  language: any;
  BoardTeams;
  page;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 
  constructor(private translationService: TranslationService,private HospitalService: HospitalService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.page = this.route.snapshot.params['page'];
    this.language = this.translationService.getSelectedLanguage();
    const sb = this.HospitalService.GetAllBoardTeamByTypeId(this.page).subscribe(res => {
      if (res != null) {
        this.BoardTeams = res;
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
